import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, HostListener, Output, ViewChild } from '@angular/core';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { GlobalService } from '@commoncore/services/global.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';

@Component({
  selector: 'common-new-create-btn',
  standalone: true,
  imports: [DependenciesModule],
  templateUrl: './new-create-btn.component.html',
  styleUrl: './new-create-btn.component.scss',
  animations: [
    trigger('fadeInOut', [
      state('void', style({ opacity: 0, transform: 'translateY(-10px)' })),
      state('*', style({ opacity: 1, transform: 'translateY(0)' })),
      transition('void <=> *', [
        animate('200ms ease-in-out')  
      ]),
    ]),
  ],
})
export class NewCreateBtnComponent {
  public listService:any;
  public universalService:any;
  shareAccessService:any;
  router:any;
  @Output() createFolder = new EventEmitter();
  @Output() createAlbum = new EventEmitter();
  loggerService: any;
  showCreateOptions:boolean = true;
  @ViewChild('createOptn', {static:false}) createOptn:ElementRef;
  albumName:any="";
  containerHeightCalc:any;
  recalculateHeightService:any;
  dropdownVisible = false;
  localStorageSvc:any;
  userDetails:any;
  fileOpCtrl: FileOperationsController;
  fileOpImplRef: any;
  constructor(public globalService:GlobalService) {
    this.setEnvObjects();
  }
  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const targetElement = event.target as HTMLElement;

    if (!targetElement.closest('.new-dropdown-container')) {
      this.dropdownVisible = false;
      let el = document.querySelector('.new-button');
      el.classList.remove('btnActive');
    }
  }
  async ngOnInit(): Promise<void> {
    this.userDetails = this.localStorageSvc.getUserData(true);
  }
  setEnvObjects(){
    this.localStorageSvc = this.globalService.getLocalStorageSvcRef();
    this.listService = this.globalService.getListServiceRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.loggerService = this.globalService.getLoggerServiceRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.router = this.globalService.getRouterRef();
    this.containerHeightCalc = this.globalService.getContainerHeightCalculatorService();
    this.recalculateHeightService = this.globalService.getContainerHeightCalculatorService();
    this.fileOpCtrl = FileOperationsController.getInstance(this.globalService);
    this.fileOpImplRef = this.fileOpCtrl.fileOperationsImplementation;
  }

  toggleDropdown() {
    this.dropdownVisible = !this.dropdownVisible;
    let el = document.querySelector('.new-button');
    if(el && this.dropdownVisible){
      el.classList.add('btnActive')
    }else{
      el.classList.remove('btnActive')
    }
  }

  uploadFile() {
    this.toggleDropdown();
    if(this.universalService.currentAlbum && this.router.url.includes(this.universalService.currentAlbum.boardKey)){
      this.uploadAlbumFiles()
    } else{
      this.universalService.fileUploadMimeType = '';
      this.universalService.isUploadFromRecentlyUploadedSection = false; 
      this.universalService.isAlbumsView = false;
      this.universalService.isUploadFromShare = false;
      AppEvents.emit(EventsList.UPLOAD_CLICKED);
    }
  }

  uploadFolder() {
    this.toggleDropdown();
    this.universalService.isAlbumsView = false;
    this.universalService.isUploadFromShare = false;
    AppEvents.emit(EventsList.UPLOAD_FOLDER_CLICKED);
  }

  newFolder() {
    setTimeout(()=>{
      let el = document.getElementById('custome_backdrop')
      if(el){
        el.style.display = 'none';
      }
    },40);
    let createModal = document.querySelector('.create-folder-modal') as any;
    if(createModal){
      createModal.classList.remove('removeModalOverlay')
    }
    this.toggleDropdown();
    this.resetValuesBeforeCreatingFolder();
    this.createFolder.emit();
    this.universalService.popUpToBeOpened = 'create Folder';
    AppEvents.globalObservable.next({createFolder:true});
  }

  newAlbum() {
    let createModal = document.querySelector('.create-album-modal') as any;
    let style = window.getComputedStyle(createModal);
    if (style.backdropFilter !== "none") {
        console.log("backdrop-filter found:");
    } else {
      createModal.style.backdropFilter = "blur(10px)"
    }
    this.toggleDropdown();
    this.resetValuesBeforeCreatingAlbum();
    this.universalService.popUpToBeOpened = 'create Album';
    // this.createAlbum.emit();
    AppEvents.globalObservable.next({createAlbum:true});
  }
  resetValuesBeforeCreatingFolder() { 
    this.fileOpImplRef.enableButton = false;
    this.listService.createFolderObject = true;
    this.universalService.disableModalBackdrop();
    this.universalService.showModalBackdrop();
  }
  resetValuesBeforeCreatingAlbum() {
    this.fileOpImplRef.enableButton = false;
    this.listService.createAlbumObject = false;
    this.universalService.disableModalBackdrop();
    this.universalService.showModalBackdrop();
  }
  newTeamFolder(){
    AppEvents.globalObservable.next({createNewTeamFolder:true});
  }

  uploadAlbumFiles(){
    this.toggleDropdown();
    this.universalService.hideEditAlbumNameBox = true;
    this.universalService.hideEditAlbumDescBox = true; 

    this.universalService.isAlbumsView = true;
    this.universalService.isUploadFromShare = false;
    AppEvents.emit(EventsList.UPLOAD_CLICKED);
  }
  
}
